import { DefaultTheme } from "styled-components";
import { createTheme } from "@mui/material/styles";

declare module "styled-components" {
    export interface DefaultTheme {
        palette: {
            common: {
                blue: string;
                gray: string;
                darkGray: string;
                lightGray: string;
                black: string;
                white: string;
                cyan: string;
                pink: string;
                fucsia: string;
                purple: string;
                red: string;
                tbBlue: string;
                tbCyan: string;
                deepSkyBlue: string;
            };
        };
        typography: {
            base: {
                main: string;
            };
        };
    }
}

declare module "@mui/material/styles" {
    interface BreakpointOverrides {
        xs: true;
        sm: true;
        md: true;
        lg: true;
        xl: true;
        xxl: true;
    }
}

// Styled-components
const theme: DefaultTheme = {
    palette: {
        common: {
            blue: "#244A78",
            gray: "#B3B3B3",
            lightGray: "#F0F0F0",
            darkGray: "#585B5E",
            black: "#000",
            white: "#FFF",
            cyan: "#20C2FF",
            pink: "#F40379",
            fucsia: "#FF1FC0",
            purple: "#C03FFF",
            red: "#ff0000",
            tbBlue: "#334768",
            tbCyan: "#1fc2ff",
            deepSkyBlue: "#22c2fc",
        },
    },
    typography: {
        base: {
            main: "Arial, sans-serif",
        },
    },
    colors: {
        primary: "#F7F7F7",
        tbMadison: "#2C3E50",
        // error: "#f9315f", @todo check type error
    },
};

// Material UI
const themeMUI = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
            xxl: 1400,
        },
    },
    palette: {
        // Keep v4-like primary tokens so controls like Checkbox color="primary"
        // retain the expected indigo tone.
        primary: {
            light: "#757de8",
            main: "#3f51b5",
            dark: "#002984",
            contrastText: "#fff",
        },
        // Restore legacy v4 secondary pink used by cancel/secondary actions.
        secondary: {
            light: "#ff4081",
            main: "#f50057",
            dark: "#c51162",
            contrastText: "#fff",
        },
    },
    typography: {
        fontFamily: "Arial, sans-serif",
    },
    components: {
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    "&.MuiCheckbox-colorPrimary.Mui-checked": {
                        color: "#3f51b5",
                    },
                },
            },
        },
        MuiButton: {
            defaultProps: {
                color: "inherit",
            },
            styleOverrides: {
                containedPrimary: {
                    backgroundColor: "#22c2fc",
                    color: "#FFF",
                    "&:hover": {
                        backgroundColor: "#1fafe2",
                    },
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                filledError: ({ theme }) => ({
                    backgroundColor: theme.palette.error.dark,
                    padding: "0px 16px",
                    marginBottom: "10px",
                }),
            },
        },
    },
});

export { theme, themeMUI };
